import moment from "moment";

export const findLastStatusEditor = (verifications = []) =>
  verifications
    .sort((verA, verB) => moment(verA.updated_at).diff(moment(verB.updated_at)))
    .at(-1)?.user.email;
